module.exports = __webpack_public_path__ + "img/alert_trade.f1b4fdc7.svg";